import $ from "jquery";
export default function employeeCustomBlock() {

        $('.employee-block').each(function () {
            const block = $(this);
            const selectedEmployees = JSON.parse(block.attr('data-selected-employees') || '[]');

            fetch('/wp-json/avu/v1/employees/')
                .then((response) => response.json())
                .then((employees) => {
                    let html = '';
                    html += '<div class="avu-employee-cards-container p-1">';
                    html += '<div class="avu-employee-cards p-1 d-flex flex-row flex-wrap overflow-hidden">';
                    employees
                        .filter((employee) => selectedEmployees.includes(employee.value.toString()))
                        .sort((a, b) => {
                            return a.lastname.localeCompare(b.lastname);
                        })
                        .forEach((employee) => {

                            html += '<div class="avu-employee-card overflow-hidden mb-1 mt-1">';
                            html += '<div class="avu-employee-card-image w-100 overflow-hidden">';
                            if(employee.img) {
                                html += `<img class="d-inline-block w-100" loading="lazy" src="${employee.img}" alt="${employee.alt}">`;
                            } else {
                                html += '<div class="avu-employee-standard-img w-100 h-100"></div>';
                            }
                            html += '</div>';
                            html += '<div class="avu-employee-card-text">';
                            html += `<p><strong>${employee.firstname} ${employee.lastname}</strong></p>`;
                            html += `<p>${employee.role}</p>`;
                            if (employee.telephoneDisplay) {
                                if (employee.telephone) {
                                    html += `<a class="d-block" href="tel:${employee.telephone}">Telefon: ${employee.telephoneDisplay}</a>`;
                                }
                            } else {
                                if (employee.telephone) {
                                    html += `<a class="d-block" href="tel:${employee.telephone}">Telefon: ${employee.telephone}</a>`;
                                }
                            }
                            if (employee.mobileDisplay) {
                                if (employee.mobile) {
                                    html += `<a class="d-block mt-1" href="tel:${employee.mobile}">Mobil: ${employee.mobileDisplay}</a>`;
                                }
                            } else {
                                if (employee.mobile) {
                                    html += `<a class="d-block mt-1" href="tel:${employee.mobile}">Mobil: ${employee.mobile}</a>`;
                                }
                            }
                            if (employee.email) {
                                html += `<a class="avu-employee-card-mail d-inline-block mt-3" href="mailto:${employee.email}">${employee.email}</a>`;
                            }
                            html += '</div>';
                            html += '</div>';
                        });
                    html += '</div>';
                    html += '</div>';
                    block.html(html);
                });
        });

}